import moment from "moment";

export const formatMonthlyTimeKeepingData = (timesheetData: Object) => {
  const firstDate = moment(Object.keys(timesheetData)[0], "DD/MM/YYYY");
  const lastDate = moment(Object.keys(timesheetData).pop(), "DD/MM/YYYY");

  // Get the start and end dates of the weeks containing the first and last dates
  const startOfWeek = firstDate.clone().startOf("week");
  const endOfWeek = lastDate.clone().endOf("week");

  // Group the dates into weeks
  const weeks = [];
  let currentWeek = [];
  let currentDate = startOfWeek.clone();

  while (
    currentDate.isBefore(endOfWeek) ||
    currentDate.isSame(endOfWeek, "day")
  ) {
    const dateString = currentDate.format("DD/MM/YYYY");
    const status = moment(dateString, "DD/MM/YYYY").isBetween(
      firstDate,
      lastDate,
      undefined,
      "[]"
    )
      ? timesheetData[dateString]
      : "outside";
    currentWeek.push({
      day: dateString,
      status,
    });

    if (currentWeek.length === 7) {
      weeks.push(currentWeek);
      currentWeek = [];
    }

    currentDate.add(1, "day");
  }

  if (currentWeek.length > 0) {
    weeks.push(currentWeek);
  }
  return weeks;
};
